import API from './api';

export const generateCode = (info) => {
    return API.post('/code', info);
}

export const generateCodeWithText = (info) => {
    return API.post('/code/text?locale=ko', info);
}

export const authorize = (code) => {
    return API.get('/code/' + code);
}

export const sendComment = (comment) => {
    console.log(comment);
    return API.post('/comment', comment);
}

export const notifyAccessMain = (game) => {
    return API.get(`/${game}/access/main`);
}

export const notifyAccessDemo = (game) => {
    return API.get(`/${game}/access/demo`);
}

export const notifyAccessMarket = (game, market) => {
    return API.get(`/${game}/access/download?market=${market}`);
}


